/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import store from '../../../components/stores/Store';
import { getAllMarkets, addNewMarket } from '../../../db/MarketRequestHandler';
// import { CheckSomething } from '../../../utils/CheckSomething';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';

import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';

const styles = {
  root: {
    // '& .MuiTextField-root': {
    //   margin: '10px',
    //   width: '25ch',
    //   textAlign: 'left',
    // },
  },
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    // width: '20ch',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};

class SelectionOfMarketManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      addDialogOpen: false,
      addDialogParams: {
        ID: '',
        marketName: '',
        remark: '',
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.addNew = this.addNew.bind(this);
    this.search = this.search.bind(this);
    this.onDialogChange = this.onDialogChange.bind(this);
    this.openAddDialog = this.openAddDialog.bind(this);
    this.closeAddDialog = this.closeAddDialog.bind(this);
  }

  async componentDidMount() {
    store.search = this.search;
    this.search();
  }
  componentWillUnmount() { }

  handleChange(event) {
    this.setState({ age: event.target.value });
  }

  onDialogChange(e, prop) {
    console.log(`----- onDialogChange-value: `, e.target.value);
    e.stopPropagation();
    const text = e.target.value;
    const newAddDialogParams = this.state.addDialogParams;
    newAddDialogParams[prop] = text;
    this.setState({ addDialogParams: newAddDialogParams });
  }

  async addNew() {
    console.log(`----- addDialogParams: `, this.state.addDialogParams);
    // 检查id
    const IDMsg = (CheckHandler.isInt({ text: this.state.addDialogParams.ID })).msg;
    const IDMsgEmp = this.state.addDialogParams.ID === '' ? '市场ID不能为空' : '';

    // 检查市场名称
    const marketName = this.state.addDialogParams.marketName.trim();
    const marketNameMsg = marketName === '' ? '市场名称不能为空' : '';
    if (IDMsgEmp || IDMsg || marketNameMsg) {
      const msg = `${IDMsgEmp}, ${IDMsg}, ${marketNameMsg}`;
      store.openMessageDialogOpen(msg);
      return;
    }

    const addDialogParams = {
      ID: this.state.addDialogParams.ID.trim(),
      marketName: this.state.addDialogParams.marketName.trim(),
      remark: (this.state.addDialogParams.remark || '').trim(),
    };

    console.log(`----- send req of  addMarket: `, addDialogParams);
    const rst = await addNewMarket(addDialogParams);
    console.log(`----- rst of addMarket: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || '新增成功');
      this.setState({ addDialogOpen: false });
      this.search();
      return true;
    }
  }

  async search() {
    if (!getIfFuncAuthorized('系统管理-市场管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }

    const rst = await getAllMarkets();
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      return true;
    }
  }

  openAddDialog() {
    this.setState({
      addDialogOpen: true,
      addDialogParams: {
        ID: '',
        marketName: '',
        remark: '',
      },
    });
  }

  closeAddDialog() {
    this.setState({
      addDialogOpen: false,
      addDialogParams: {
        ID: '',
        marketName: '',
        remark: '',
      },
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('系统管理-市场管理-新增')) && (
            <Button color="primary" variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.openAddDialog()}
            >
              新增市场
            </Button>
          )}

          <Button color="primary" variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            刷新
          </Button>
        </form>
        <Dialog aria-labelledby="form-dialog-title"
          open={this.state.addDialogOpen}
          onClose={e => this.closeAddDialog()}>
          <DialogTitle id="form-dialog-title" style={{ width: '300px' }}>
            新增市场
          </DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="marketId"
              label="市场ID"
              fullWidth

              onChange={e => this.onDialogChange(e, 'ID')}
              ivalue={this.state.addDialogParams.ID}
              type="int"
              notNull
              maxLength='4'
            />
            <ITextField
              margin="dense"
              id="marketName"
              label="市场名称"
              fullWidth

              onChange={e => this.onDialogChange(e, 'marketName')}
              ivalue={this.state.addDialogParams.marketName}
              type="text"
              notNull
              maxLength='10'
            />
            <ITextField
              margin="dense"
              id="remark"
              label="备注"
              fullWidth

              onChange={e => this.onDialogChange(e, 'remark')}
              ivalue={this.state.addDialogParams.remark}
              type="text"
              maxLength='30'
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.addNew} color="primary" variant="contained"
              aria-label="contained primary button group">
              确认添加
            </Button>
            <Button onClick={e => this.closeAddDialog()}
              color="primary" variant="contained"
              aria-label="contained primary button group">
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfMarketManagement = observer(SelectionOfMarketManagementInner);

SelectionOfMarketManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfMarketManagement);
